import { useQuery, useMutation, useQueryClient } from '@/lib/query';
import { getKipiverseInquiries, getKipiverseInquiryById, updateKipiverseInquiryStatus } from '../services/kipiverse-inquiry.service';

export const useGetKipiverseInquiries = (params?: {
  page?: number;
  limit?: number;
  status?: string;
  sortColumn?: string;
  sortBy?: string;
  order?: 'ASC' | 'DESC';
}) => {
  return useQuery({
    queryKey: ['kipiverseInquiries', params],
    queryFn: () => getKipiverseInquiries(params),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};

export const useGetKipiverseInquiryById = (id: string) => {
  return useQuery({
    queryKey: ['kipiverseInquiries', id],
    queryFn: () => getKipiverseInquiryById(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000,
  });
};

export const useUpdateKipiverseInquiryStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: { status: string } }) =>
      updateKipiverseInquiryStatus(id, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['kipiverseInquiries'] });
      queryClient.invalidateQueries({ queryKey: ['kipiverseInquiries', variables.id] });
    },
  });
};
